import styles from './delete-picture-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest } from 'libs/webkua-lib/src/lib/requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeletePictureDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  deleteImage: () => void
}

export function DeletePictureDialog(props: DeletePictureDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteFile = () => {
    setLoading(true);
    makeCourseRequest(`deleteFile/${props.deleteImage.name}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deletePicture.deletedImageFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deletePicture.couldNotDeleteImageFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deletePicture.areYouSureYouWantToDeletePicture')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {props.deleteImage.name}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteFile}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeletePictureDialog;
